// @flow

import React from 'react';
import { defineMessages, useIntl, FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/styles';
import { BaseText, Grid, Header2 } from '@catalytic/catalytic-ui';
import errorUrl from '../images/error.svg';

const Messages = defineMessages({
  error: {
    defaultMessage: 'Hmm. Well, this is unexpected.',
    id: 'errorPage'
  }
});

export const useStyles = makeStyles(theme => ({
  image: {
    marginBottom: '1rem',
    maxWidth: '11rem',
    width: '100%'
  },
  description: {
    ...theme.mixins.formMarginBottom,
    marginTop: '.5rem',
    color: theme.colors.slateGrey,
    textAlign: 'center',
    [theme.breakpoints.gt.mobile.portrait]: {
      maxWidth: '30rem',
      width: '100%'
    },
    '& a': {
      fontWeight: 500
    }
  }
}));

const ErrorPage = () => {
  const intl = useIntl();
  const classes = useStyles();

  return (
    <Grid
      alignItems="center"
      container
      data-testid="error-page"
      direction="column"
    >
      <img
        className={classes.image}
        src={errorUrl}
        alt={intl.formatMessage(Messages.error)}
      />
      <Header2>
        <FormattedMessage {...Messages.error} />
      </Header2>
      <BaseText className={classes.description}>
        <FormattedMessage
          id="errorPage.description"
          defaultMessage="An error has occurred when loading this page.{br}{br}Please try reloading the page.{br}{br}If that doesn't do the trick, we actively monitor for issues like this and will address it as quickly as possible.{br}{br}You can view the current status at {status}. If you have questions, please contact us at {help}."
          values={{
            br: <br />,
            help: (
              <a
                href="mailto:help@catalytic.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                help@catalytic.com
              </a>
            ),
            status: (
              <a
                href="https://status.catalytic.com/"
                rel="noopener noreferrer"
                target="_blank"
              >
                status.catalytic.com
              </a>
            )
          }}
        />
      </BaseText>
    </Grid>
  );
};
ErrorPage.displayName = 'ErrorPage';

export default ErrorPage;
